module.exports = __webpack_public_path__ + "dashboard/img/tags_dark.e58b82fe49f2915b4fb892ac50467ced.svg";